<template>
  <div>
    <div class="wrapper">
      <div v-if="isShowBar" class="content" :style="{width: `${branchList.length * 25 + 8}vw`}">
        <span :class="{'active': activeIndex === index}" class="bar-item" v-for="(item, index) in branchList" :key="item.city + '' + index" @click="barHandler(index)">
          {{`${item.name}`}}
        </span>
      </div>
      <div v-if="isShowBar" class="menu" @click="showMenuA">
        <span class="menu-icon"></span>
      </div>
      <div v-if="isShowMenu" class="menu-content" @touchmove.stop.prevent>
        <div class="menu-title">全部</div>
        <ul class="menu-box">
          <li class="menu-item" v-for="(mItem, mIndex) in branchList" :key="mItem.city + '&' + mIndex" @click="barHandler(mIndex)">{{`${mItem.name}`}}</li>
        </ul>
      </div>
    </div>
    <div v-if="fixedBar" :class="{'top': ismenuTop}" class="wrapper fixed">
      <div v-if="isShowBar" class="content" :style="{width: `${branchList.length * 25 + 8}vw`}">
        <span :class="{'active': activeIndex === index}" class="bar-item" v-for="(item, index) in branchList" :key="item.city + '' + index" @click="barHandler(index)">
          {{`${item.name}`}}
        </span>
      </div>
      <div v-if="isShowBar" class="menu" @click="showMenuB">
        <span class="menu-icon"></span>
      </div>
      <div v-if="isShowMenu" class="menu-content" @touchmove.stop.prevent @click="hiddenMenu">
        <div class="menu-title">全部</div>
        <ul class="menu-box">
          <li class="menu-item" v-for="(mItem, mIndex) in branchList" :key="mItem.city + '&' + mIndex" @click.stop="barHandler(mIndex)">{{`${mItem.name}`}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import VueBus from '@/util/vueBus'

export default {
  data () {
    return {
      barDom: null,
      rightStopX: null,
      startX: null,
      activeIndex: 0,
      isShowMenu: false,
      isShowBar: true,
      fixedBar: false,
      ismenuTop: false
    }
  },
  props: ['branchList'],
  mounted () {
    var _self = this
    window.addEventListener('scroll', function () {
      if (window.pageYOffset >= 48) {
        _self.fixedBar = true
      } else {
        _self.fixedBar = false
      }
    }, false)
  },
  methods: {
    hiddenMenu () {
      this.isShowBar = true
      this.isShowMenu = false
      this.ismenuTop = false
    },
    showMenuA () {
      this.isShowBar = false
      this.isShowMenu = true
    },
    showMenuB () {
      this.isShowBar = false
      this.isShowMenu = true
      this.ismenuTop = true
    },
    barHandler (index) {
      this.ismenuTop = false
      this.isShowBar = true
      this.isShowMenu = false
      this.activeIndex = index
      VueBus.$emit('scrollToTargetBranch', index)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/bulma/app.sass';

.wrapper {
  // position: relative;
  // top: 0;
  // left: 0;
  width: 100%;
  height: 40px;
  overflow-x: scroll;
  overflow-y: hidden;
  background: #fff;
  box-shadow:0px 6px 12px 1px rgba(0, 0, 0, 0.1);
  z-index: 8;
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    .menu {
      position: fixed;
      top: 0;
      right: 0;
    }
    .menu-content {
      top: 0;
      left: 0;
      z-index: 9;
    }
  }
  &.top {
    height: 100vh;
  }

  .menu {
    position: absolute;
    top: 48px;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background: #fff;
    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 2px;
        height: 15px;
        background:rgba(136, 136, 136, 0.2);
    }

    .menu-icon {
      position: relative;
      display: block;
      width: 18px;
      height: 15px;
      border-top: 2px solid #888;
      border-bottom: 2px solid #888;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 18px;
        height: 2px;
        background: #888;
      }
    }

  }

  .menu-content {
    position: fixed;
    background: #fff;
    left: 0;
    top: 40px;
    width: 100vw;
    height: 100vh;
    padding: 0 4vw;
    z-index: 8;

    .menu-title {
      display: inline-block;
      margin-top: 6vw;
      font-size: 5vw;
      font-weight: 600;
      border-bottom: 3px solid $primary3;
    }

    .menu-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      border-top: 2px solid #EBEBEB;
      margin-top: -1px;
      padding-top: 6vw;

      .menu-item {
        width: 27vw;
        background: #F2F2F2;
        padding: 1vw 0;
        text-align: center;
        margin-bottom: 4vw;
        border-radius: 3px;
      }
    }
  }

  .content {
    // position: absolute;
    // top: 0;
    // left: 0;
    font-size: 14px;
    height: 100%;
    line-height: 40px;
    background-color: transparent;

    .bar-item {
      color: #888;
      float: left;
      display: block;
      width: 25vw;
      text-align: center;
      box-sizing: border-box;
      background: #fff;
      &.active {
        color: #CBAB76;
      }
    }
  }
}
</style>
